import axios from '@/utils/axios'
// 组件列表
export function listModule(query) {
    return axios({
        url: '/novel/module/list',
        method: 'get',
        params: query
    })
}
// 添加
export function addModule(query) {
    return axios({
        url: '/novel/module/addOrUpdModule/save',
        method: 'post',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/novel/module/addOrUpdTemplate',
        method: 'get',
        params: query
    })
}
// 删除模板
export function delModule(query) {
    return axios({
        url: '/novel/module/delModule/save',
        method: 'post',
        params: query
    })
}
// 书籍列表
export function listBook(query) {
    return axios({
        url: '/novel/module/configModuleData',
        method: 'get',
        params: query
    })
}
// 书籍列表
export function listBookAdd(query) {
    return axios({
        url: '/novel/module/addModuleData/save',
        method: 'post',
        params: query
    })
}
// 添加书籍列表
export function updBookData(query) {
    return axios({
        url: '/novel/module/updVideoData/save',
        method: 'post',
        params: query
    })
}
// 详情
export function detailsBook(query) {
    return axios({
        url: '/novel/module/updVideoData',
        method: 'get',
        params: query
    })
}
// 删除书籍
export function delBook(query) {
    return axios({
        url: '/novel/module/delVideoData/save',
        method: 'post',
        params: query
    })
}
// 组件类型列表
export function moduleType(query) {
    return axios({
        url: '/novel/module/getModuleNameTypeInfo',
        method: 'get',
        params: query
    })
}
// 组件类型列表
export function moduleStyle(query) {
    return axios({
        url: '/novel/module/getModuleNovelModuleTypeStyleInfo',
        method: 'get',
        params: query
    })
}
// 短篇下的二级分类列表
export function listBookSort(query) {
    return axios({
        url: '/booklist/getShortBookSort',
        method: 'get',
        params: query
    })
}
// 一级分类列表
export function listBookSortFirst(query) {
    return axios({
        url: '/booklist/getLongBookSort',
        method: 'get',
        params: query
    })
}
// 二级分类列表
export function moduleBookSort(query) {
    return axios({
        url: '/novel/module/getModuleBookSort',
        method: 'get',
        params: query
    })
}
// 二级分类列表
export function moduleBookSortFirst(query) {
    return axios({
        url: '/novel/module/getModuleLongBookSort',
        method: 'get',
        params: query
    })
}
// 二级分类列表
export function saveBookSort(query) {
    return axios({
        url: '/booklist/getShortBookSort',
        method: 'post',
        params: query
    })
}